// extracted by mini-css-extract-plugin
module.exports = {"Skills":"Skills_Skills__2xCDS","skillText":"Skills_skillText__30EzW","toolsList":"Skills_toolsList__2sR55"};